// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs, Autoplay, EffectFade } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/swiper-bundle.css';

// init Swiper:
const swiper = new Swiper('.swiper--std', {
  // configure Swiper to use modules
  modules: [Navigation, Pagination],
    direction: 'horizontal',
    loop: true,

    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper--next',
        prevEl: '.swiper--prev',
    },

    // And if we need scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
    }
});
const swiperTestimonial = new Swiper('.swiper--testimonial', {
  // configure Swiper to use modules
  modules: [Navigation, Pagination, Autoplay, EffectFade],
    direction: 'horizontal',
    loop: true,
    navigation: {
        nextEl: '.swiper--next',
        prevEl: '.swiper--prev',
    },
    speed: 500,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    // autoplay: {
    //     delay: 3000,
    // },
});


// Function to get CSS variable as a computed pixel value with fallback
const getCssVarAsPixel = (varName, fallback = 10) => {
    // Create a temporary element
    const tempElement = document.createElement('div');
    tempElement.style.display = 'none';
    tempElement.style.width = `var(${varName})`;
    document.body.appendChild(tempElement);
    
    // Get computed width
    const computedValue = parseFloat(getComputedStyle(tempElement).width);
    
    // Clean up
    tempElement.remove();
    
    return isNaN(computedValue) ? fallback : computedValue;
};

// Wait for DOM to load
document.addEventListener('DOMContentLoaded', () => {
    // Find all main sliders
    const mainSliders = document.querySelectorAll('.swiper--main');
    console.log('Found main sliders:', mainSliders.length);

    mainSliders.forEach((mainContainer, index) => {
        // Use existing unique class if available (e.g., schiff-slider-1-main)
        let uniqueClass = Array.from(mainContainer.classList).find(cls => cls.startsWith('schiff-slider-'))?.replace('-main', '');
        if (!uniqueClass) {
            uniqueClass = `schiff-slider-${index}`;
            mainContainer.classList.add(`${uniqueClass}-main`);
        }

        // Find corresponding thumb slider
        const thumbContainer = document.querySelector(`.${uniqueClass}-thumb`) || mainContainer.parentElement.querySelector('.swiper--thumb') || document.querySelectorAll('.swiper--thumb')[index];
        if (!thumbContainer || !thumbContainer.querySelector('.swiper-wrapper')) {
            console.warn(`No valid thumb slider found for main slider ${uniqueClass}`);
            return;
        }
        thumbContainer.classList.add(`${uniqueClass}-thumb`);

        // Initialize Thumbnail Swiper
        const thumbSwiper = new Swiper(`.${uniqueClass}-thumb`, {
            modules: [Thumbs],
            slidesPerView: 4,
            spaceBetween: getCssVarAsPixel('--space-6', 10),
            freeMode: true,
            watchSlidesProgress: true,
        });

        // Verify thumbSwiper is initialized
        if (!thumbSwiper.el) {
            console.warn(`Thumb swiper failed to initialize for ${uniqueClass}`);
            return;
        }

        // Initialize Main Swiper
        new Swiper(`.${uniqueClass}-main`, {
            modules: [Thumbs],
            direction: 'horizontal',
            loop: true,
            thumbs: {
                swiper: thumbSwiper,
            },
        });
    });
});